import { FC, ReactNode } from 'react';
import { ReactComponent as WarningIcon } from 'assets/icons/warning.svg';
import { Controller, FieldValues, RegisterOptions } from 'react-hook-form';

interface TextFieldProps {
  id: string;
  control: any;
  placeholder?: string;
  label?: string;
  rules?: Omit<
    RegisterOptions<FieldValues, string>,
    'valueAsNumber' | 'valueAsDate' | 'setValueAs' | 'disabled'
  >;
  defaultValue?: string;
  disabled?: boolean;
  iconHelper?: ReactNode;
  navigator?: ReactNode;
}

const TextField: FC<TextFieldProps> = ({
  id,
  label,
  placeholder,
  disabled,
  iconHelper,
  navigator,
  ...props
}) => {
  return (
    <div className="flex flex-col gap-y-0.8 relative">
      {label && (
        <label
          className="text-darkest-grey text-16 leading-[2.4rem] font-bold"
          htmlFor={id}
        >
          {label}
        </label>
      )}
      <Controller
        name={id}
        {...props}
        render={({ field, fieldState: { error } }) => {
          return (
            <>
              <div className="relative">
                <input
                  id={id}
                  type="text"
                  className={`w-full h-4.8 text-14 py-1.3 pl-1.6 pr-4.5 rounded-[1rem] border-[0.5px] placeholder:text-mid-grey ${
                    error?.message
                      ? 'shadow-input-error border-[#f44336] hover:border-[#f44336] hover:shadow-input-error focus:border-[#f44336] focus:shadow-input-error'
                      : 'shadow-primary border-lightest-grey hover:border-magenta hover:shadow-input-active focus:border-magenta focus:shadow-input-active'
                  } ${disabled ? 'text-mid-grey' : ''}`}
                  placeholder={placeholder}
                  disabled={disabled}
                  {...field}
                  onChange={(event) => field.onChange(event.target.value)}
                />
                {navigator}
              </div>
              {iconHelper}
              {error?.message && (
                <div className={`flex items-center gap-x-1 mt-0.2`}>
                  <WarningIcon />
                  <span className="text-12 text-red-01">{error.message}</span>
                </div>
              )}
            </>
          );
        }}
      />
    </div>
  );
};

export default TextField;
